import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac6ffdea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  class: "btn-group btn-group-sm",
  role: "group",
  "aria-label": "Responsibility"
}
const _hoisted_3 = ["title", "innerHTML"]

import { computed, ref, inject } from 'vue';
import { useStore } from 'vuex';
import _get from "lodash/get";
import { ReportsState } from '@/store/reports/types';
import { Note } from '@/models';

interface IResponsibilityOption {
  code: string;
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConditionResponsibilities',
  props: {
    notePath: {}
  },
  setup(__props: any) {

const store = useStore();
const actProperty: any = inject('actProperty');

// Props and injections
const props = __props;
const reportsState = computed(() => store.state.reports as ReportsState);

const setReportDeep = async (payload: { path: string; data: any }) => {
  await store.dispatch('reports/setReportDeep', payload);
};

const note = computed<Note>(() => {
  return _get(reportsState.value.current, props.notePath);
});

const responsibility = computed<string[]>({
  get: () => _get(note.value, 'responsibility', []),
  set: (data) => {
    setReportDeep({
      path: `${props.notePath}.responsibility`,
      data,
    });
  },
});

/**
 * Interface defines the syntax properties which the Responsibilities must follow
 */
 const options = [
  { code: "TT", name: "Tenant" },
  { code: "STTA", name: "Subject To Tenancy Agreement" },
  { code: "CLN", name: "Cleaning" },
  { code: "FWT", name: "Fair Wear and Tear" },
  { code: "CLR", name: "Clarify" },
  { code: "INF", name: "Information Only" },
  { code: "LL", name: "Landlord" },
];

// Methods converted to regular arrow functions
const responsibilitySelectedClassName = (option: IResponsibilityOption) => {
  let className = `btn btn-${option.code.toLowerCase()} `;

  if (responsibility.value === undefined) {
    return className;
  }

  if (Array.isArray(responsibility.value)) {
    className += responsibility.value.includes(option.code.toUpperCase())
      ? "selected"
      : "";
  } else {
    actProperty.displayError(
    Error(
      `The Note Responsibility is not an array: ${JSON.stringify(
        responsibility.value
      )}`
    ));
  }

  return className;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (option) => {
        return _createElementVNode("button", {
          key: option.code,
          type: "button",
          class: _normalizeClass(responsibilitySelectedClassName(option)),
          title: option.name,
          innerHTML: option.code
        }, null, 10, _hoisted_3)
      }), 64))
    ])
  ]))
}
}

})